angular
    .module('empower.termCondition')
    .controller('termConditionAgreementController', ['$rootScope', '$scope', '$filter', 'popupService', 'termConditionServices', 'userService',
        function($rootScope, $scope, $filter, popupService, termConditionServices, userService) {
        $scope.disableAgreeBtn = true;

        $scope.init = function () {
            termConditionServices.getTermCondition().then(function (response) {
                $scope.termsConditions = response;
            });
        }

        $scope.disagree = function() {
            popupService.showText("You must agree to the Terms and Conditions to use Empower. You will be redirected to the login page.", undefined, $rootScope.userLogout);
        }

        $scope.agree = function() {
            termConditionServices.agreeTermCondition().then(function(data) {
                sessionStorage.setItem('IsAcceptTermCondition', $filter('enstr64')(true));
                popupService.hide();
                userService.setUserArray();
            });
        }

        $scope.scrollBottom = function() {
            $scope.disableAgreeBtn = false;
        }
    }]);
